<template>
  <div>
    <div class="flex flex-col items-start gap-2 md:flex-row md:items-center md:justify-between">
      <h2>{{ t('counters') }}</h2>
      <CVButton class="w-full md:w-auto" @click.prevent="push({ name: '' })">
        {{ t('addCounter') }}
      </CVButton>
    </div>

    <div v-if="fields.length" class="mb-4 mt-4 rounded-md bg-white pb-1 pl-4 pr-4 pt-1">
      <div
        v-for="(counter, i) in fields"
        :key="counter.key"
        class="relative pb-3 pr-8 pt-3"
        :class="{
          'border-b': i < fields.length - 1,
        }"
      >
        <InputField v-if="counter.value.id" :name="`counters[${i}].id`" class="hidden" />
        <InputField :name="`counters[${i}].name`" :label="t('counterName')" />
        <button
          class="absolute bottom-5 right-0 cursor-pointer p-2 text-lg leading-3 text-bittersweet-600"
          @click.prevent="remove(i)"
        >
          ×
        </button>
      </div>
    </div>
    <p v-else class="mt-4 text-sm text-gray-500">{{ t('noCounters') }}</p>
  </div>
</template>

<script lang="ts" setup>
import InputField from '@/components/InputField.vue';
import { useI18n } from 'vue-i18n';
import { useFieldArray } from 'vee-validate';

interface CounterFormValues {
  id?: string;
  name: string;
}

const { t } = useI18n();
const { push, remove, fields } = useFieldArray<CounterFormValues>('counters');
</script>

<i18n lang="json">
{
  "en": {
    "counters": "Counters",
    "addCounter": "+ Add counter",
    "counterName": "Counter name",
    "noCounters": "No counters configured yet."
  },
  "de": {
    "counters": "Schalter",
    "addCounter": "+ Schalter hinzufügen",
    "counterName": "Schaltername",
    "noCounters": "Noch keine Schalter konfiguriert."
  },
  "es": {
    "counters": "Mostradores",
    "addCounter": "+ Añadir mostrador",
    "counterName": "Nombre del mostrador",
    "noCounters": "Aún no hay mostradores configurados."
  }
}
</i18n>
